module.exports = __webpack_public_path__ + "img/4c3c4a0.jpg";